/* eslint-disable array-bracket-newline */
import { useEffect } from 'react';
import BigNumber from 'bignumber.js';
import { NativeCoin } from '../helpers/nativeCoins';
import { Address, formatEther } from 'viem';
import { fetchEVMBalance } from '../../../helpers/fetchEVMBalance';

interface IUseLimitNativeTokenArgs {
  proxyAddress?: string;
  chainId: number;
  setNativeToken(data: {
    name?: string;
    amount?: number;
    loading?: boolean;
    error?: boolean;
  }): void;
}

const useLimitNativeToken = ({
  proxyAddress,
  chainId,
  setNativeToken,
}: IUseLimitNativeTokenArgs) => {
  useEffect(() => {
    if (proxyAddress) {
      fetchNativeTokenBalance();
    } else {
      setNativeToken({
        loading: false,
        error: true,
      });
    }
  }, [proxyAddress]);

  useEffect(() => {
    const nativeCoin = NativeCoin(chainId, new BigNumber(0));
    setNativeToken({ name: nativeCoin.name });
  }, [chainId]);

  /**
   * Get balance of native currency (ETH) of proxy wallet
   * @param address - proxy wallet address
   */
  const fetchNativeTokenBalance = async () => {
    setNativeToken({ loading: true, error: false });
    try {
      const balance = await fetchEVMBalance({
        address: proxyAddress as Address,
      });
      const res = formatEther(balance.value);
      setNativeToken({
        amount: Math.round(Number(res) * 1e4) / 1e4,
        loading: false,
        error: false,
      });
    } catch (err) {
      console.warn(err);
      setNativeToken({ amount: 0, loading: false, error: true });
    }
  };

  return { fetchNativeTokenBalance };
};

export default useLimitNativeToken;
